/**
 * frontend/src/pages/valuation/_MarketOnlyAck.tsx
 *
 * VAL-PATH-P6a T7 — the one market-only acknowledgement. Methodology
 * (_TuningSignoffColumn) and Your value (ValuationOutput) both render it;
 * the text lives here only. Presentational: the caller owns the state.
 */
import type { ComputedPayload, RecomputeResponse } from '@/types/valuationB3'

export const MARKET_ONLY = 'n/a — market approach only'

/** The run rests on the market approach alone (no income approach value). */
export function isMarketOnlyRun(run: Pick<ComputedPayload | RecomputeResponse, 'convergence_status'> | null | undefined): boolean {
  return run?.convergence_status === MARKET_ONLY
}

export function MarketOnlyAck({
  checked,
  onChange,
}: {
  checked: boolean
  onChange: (value: boolean) => void
}) {
  return (
    <label className="flex items-start gap-2 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">
      <input
        type="checkbox"
        className="mt-0.5"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
      />
      <span>
        No income approach value was supplied. This calculated value rests on the market
        approach alone and is <strong>not triangulated</strong> — I acknowledge this before
        continuing.
      </span>
    </label>
  )
}
